var ARROWS_TYPE = {
    DEFAULT_ARROW: 0,
    ARROW1: 1,
    ARROW2: 2,
};
export default ARROWS_TYPE;
//# sourceMappingURL=arrowsType.js.map